import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { FounderMessagesManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/founder-messages")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <FounderMessagesManagement />
    </RouteGuard>
  ),
});
